<template>
  <div class="list-page">
    <div class="detail-banner">
      <div class="container">
        <h1>行业专家</h1>
      </div>
    </div>
    <section class="section">
      <div class="container">
        <span class="detail-back" @click="$goBack()">‹ 返回</span>

        <!-- 专家类别 tabs -->
        <div class="tabs" v-if="tabs.length">
          <button
            v-for="t in tabs"
            :key="t.code"
            class="tab"
            :class="{ active: activeType === t.code }"
            @click="switchType(t.code)"
          >{{ t.name }}</button>
        </div>

        <div class="card-grid" v-if="rows.length">
          <div
            v-for="item in rows"
            :key="item.id"
            class="card expert-card-item"
            @click="$router.push('/expert/' + item.id)"
          >
            <div class="expert-cover">
              <img v-if="item.cover" :src="item.cover" :alt="item.name" @error="onImgError" />
              <span v-else>{{ item.name.slice(0, 1) }}</span>
            </div>
            <div class="card-body">
              <div class="card-title">{{ item.name }}</div>
              <div class="card-desc">{{ item.tags }}</div>
              <div class="card-detail-btn">查看详情</div>
            </div>
          </div>
        </div>

        <div class="empty-block" v-else-if="!loading">该分类暂无专家</div>
        <div class="empty-block" v-else>加载中…</div>

        <!-- 分页 -->
        <div class="pager" v-if="totalPages > 1">
          <button class="pg-btn" :disabled="pageNum <= 1" @click="goPage(pageNum - 1)">‹ 上一页</button>
          <button
            v-for="p in pages"
            :key="p"
            class="pg-num"
            :class="{ active: p === pageNum }"
            @click="goPage(p)"
          >{{ p }}</button>
          <button class="pg-btn" :disabled="pageNum >= totalPages" @click="goPage(pageNum + 1)">下一页 ›</button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { fetchExpertTypes, fetchExpertsPage } from '../api/home'

export default {
  name: 'ExpertsList',
  data () {
    return {
      tabs: [],
      activeType: '',
      rows: [],
      pageNum: 1,
      pageSize: 8,
      total: 0,
      loading: true
    }
  },
  computed: {
    totalPages () {
      return Math.max(1, Math.ceil(this.total / this.pageSize))
    },
    pages () {
      const tp = this.totalPages
      const cur = this.pageNum
      if (tp <= 7) return Array.from({ length: tp }, (_, i) => i + 1)
      const set = new Set([1, tp, cur, cur - 1, cur + 1, cur - 2, cur + 2])
      const arr = [...set].filter(p => p >= 1 && p <= tp).sort((a, b) => a - b)
      const out = []
      let prev = 0
      for (const p of arr) {
        if (p - prev > 1) out.push('...')
        out.push(p)
        prev = p
      }
      return out
    }
  },
  created () {
    this.loadTypes()
    this.load()
  },
  methods: {
    async loadTypes () {
      try {
        this.tabs = await fetchExpertTypes()
      } catch (e) {
        this.tabs = [{ code: '', name: '全部' }]
      }
    },
    async load () {
      this.loading = true
      try {
        const res = await fetchExpertsPage({
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          expertType: this.activeType
        })
        this.rows = res.rows
        this.total = res.total
      } catch (e) {
        this.rows = []
        this.$toast.show({ message: (e && e.message) || '加载失败', type: 'error' })
      } finally {
        this.loading = false
      }
    },
    switchType (code) {
      if (code === this.activeType) return
      this.activeType = code
      this.pageNum = 1
      this.load()
    },
    goPage (p) {
      if (p < 1 || p > this.totalPages || p === this.pageNum) return
      this.pageNum = p
      this.load()
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    onImgError (e) {
      e.target.style.display = 'none'
    }
  }
}
</script>

<style scoped>
.tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 26px;
}
.tab {
  border: 1px solid var(--border);
  background: #fff;
  color: var(--text-sub);
  padding: 7px 18px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.25s ease;
}
.tab:hover { border-color: var(--primary); color: var(--primary); }
.tab.active {
  background: var(--primary);
  border-color: var(--primary);
  color: #fff;
}
.expert-cover {
  height: 200px;
  background: #f4f7fe;
  color: var(--primary);
  font-size: 46px;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.expert-cover img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.pager {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-top: 34px;
  flex-wrap: wrap;
}
.pg-btn,
.pg-num {
  min-width: 38px;
  height: 38px;
  padding: 0 12px;
  border: 1px solid var(--border);
  background: #fff;
  color: var(--text-main);
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.pg-btn:hover:not(:disabled),
.pg-num:hover {
  border-color: var(--primary);
  color: var(--primary);
}
.pg-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.pg-num.active {
  background: var(--primary);
  border-color: var(--primary);
  color: #fff;
}
.pager :not(button) {
  color: var(--text-sub);
  padding: 0 4px;
}
.empty-block {
  text-align: center;
  color: var(--text-sub);
  padding: 40px 0;
}
</style>
